import { Routes } from '@angular/router';
import { WatchlistCompanyComponent } from './company/company.component';
import { WatchlistProjectComponent } from './project/project.component';
import { WatchlistCountrySectorComponent } from './country-sector/country-sector.component';

export const watchlistsRoutes: Routes = [
  { path: 'company-watchlist', redirectTo: 'watchlists/company', pathMatch: 'full' },
  { path: 'project-watchlist', redirectTo: 'watchlists/project', pathMatch: 'full' },
  { path: 'country-industry-watchlist', redirectTo: 'watchlists/country-sector', pathMatch: 'full' },
  {
    path: 'watchlists',
    children: [
      { path: 'company', component: WatchlistCompanyComponent },
      { path: 'project', component: WatchlistProjectComponent },
      { path: 'country-sector', component: WatchlistCountrySectorComponent },
      { path: '', redirectTo: 'company', pathMatch: 'full' },
    ],
  },
];
